//Prod url

// const GlobalVariable = Object.freeze({
//     BASE_API_URL: "https://rfpapi.mitresource.com/rfp_portal",
//   });

// export default GlobalVariable;

// dev

const GlobalVariable = Object.freeze({
        BASE_API_URL:  "https://rfptestbackendapi.smartranserp.com/rfp_portal",   
});

export default GlobalVariable;
